import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import SectionHeading from '../../../components/SectionHeading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OverviewModalCurriculumSection = ({
  children,
  isPlaylistOverview
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(View, {
    backgroundColor: isPlaylistOverview ? 'fill-surface-recessed' : undefined,
    borderRadius: isPlaylistOverview ? '300' : undefined,
    marginBlock: isPlaylistOverview ? '800' : undefined,
    padding: isPlaylistOverview ? '800' : undefined,
    children: [/*#__PURE__*/_jsx(SectionHeading, {
      paddingBlockStart: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyComponents.overviewModal.curriculum"
      })
    }), /*#__PURE__*/_jsx(View, {
      borderRadius: isPlaylistOverview ? '300' : undefined,
      marginBlock: isPlaylistOverview ? '600' : undefined,
      children: /*#__PURE__*/_jsx(View, {
        paddingInline: isMobile ? '300' : undefined,
        children: children
      })
    })]
  });
};
export default OverviewModalCurriculumSection;